import { render, staticRenderFns } from "./HomeFeature.vue?vue&type=template&id=e80eaf46&scoped=true&"
import script from "./HomeFeature.vue?vue&type=script&lang=js&"
export * from "./HomeFeature.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeature.vue?vue&type=style&index=0&id=e80eaf46&lang=scss&scoped=true&"
import style1 from "./HomeFeature.vue?vue&type=style&index=1&id=e80eaf46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80eaf46",
  null
  
)

export default component.exports